export interface Point {
    lat: number;
    lng: number;
}

export interface Place extends Point {
    formattedAddress?: string;
}

/**
 * True when both members are finite numbers.
 * Rejects undefined/null objects, NaN, Infinity, and non-number members
 * (e.g. rehydrated `null` from JSON.stringify(NaN)).
 */
export function isValidPoint(point: unknown): point is Point {
    if (!point || typeof point !== 'object') {
        return false;
    }
    const { lat, lng } = point as Point;
    return Number.isFinite(lat) && Number.isFinite(lng);
}
